// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { ValidationsFragment } from './ValidateImporterColumn.graphql';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
import { ValidationsFragmentDoc } from './ValidateImporterColumn.graphql';
export type ValidateImporterEngagementTableQueryVariables = Types.Exact<{
  input: Types.EngagementDateEffectiveValidationQueryModelInput;
}>;

export type ValidateImporterEngagementTableQuery = {
  result: { validations?: Array<ValidationsFragment | null> | null };
};

export const ValidateImporterEngagementTableDocument = gql`
    query ValidateImporterEngagementTable($input: EngagementDateEffectiveValidationQueryModelInput!) {
  result: validateEngagementHasPropertySet(input: $input) {
    validations {
      ...Validations
    }
  }
}
    ${ValidationsFragmentDoc}` as unknown as DocumentNode<
  ValidateImporterEngagementTableQuery,
  ValidateImporterEngagementTableQueryVariables
>;
